export const PIPELINE_ADMIN_LOGIN_PATH = '/pipeline-admin/login'
export const PIPELINE_ADMIN_VERIFY_2FA_PATH = '/pipeline-admin/verify-2fa'
export const PIPELINE_ADMIN_INDEX_PATH = '/pipeline-admin'
export const PIPELINE_ADMIN_SESSION_EXPIRED_PATH = '/pipeline-admin/session-expired'

export const PIPELINE_ADMIN_2FA_COPY = {
  title: 'Enter your 2FA code',
  subtitle: 'Sent to your email',
  verifyLabel: 'VERIFY',
  resendPrefix: "Didn't receive code?",
  resendAction: 'Resend',
  resendCountdownPrefix: 'Resend in',
  backToLogin: 'Back to Login',
  resendCooldownSeconds: 45,
  invalidCodeMessage: 'Invalid code. Please try again.',
}

export const PIPELINE_ADMIN_LOGIN_COPY = {
  brand: {
    title: 'Strategy Pipeline',
    description:
      'Track competitive signals, diagnosis, solutions and shipped initiatives across the organization.',
    uptime: '99.9% Uptime',
    status: 'Platform Status: Optimal',
  },
  form: {
    title: 'Welcome Back',
    subtitle: 'Sign in to access the strategy pipeline panel.',
    emailLabel: 'Email Address',
    passwordLabel: 'Password',
    rememberMe: 'Remember me',
    submitLabel: 'LOGIN TO PIPELINE',
    footer: 'Secure login for pipeline staff — Powered by Systems',
  },
}

export const PIPELINE_ADMIN_SESSION_EXPIRED_COPY = {
  title: 'Session Expired',
  subtitle:
    'Your session expired for security. Please sign back in to continue.',
  buttonLabel: 'Login Again',
}